import "./styles.css";
import { Legal } from "./pages/Legal";
import { TERMS_MD } from "./pages/legalContent";
import { mount } from "./hydrate";

mount(
  <Legal
    title="Terms of Service"
    content={TERMS_MD}
    otherHref="/privacy/"
    otherLabel="our Privacy Policy"
  />,
);
